import { useSelector } from 'react-redux'
import { Input } from 'antd'
import { faCalendarStar, faEnvelopeOpenText, faGraduationCap } from '@fortawesome/pro-solid-svg-icons'

import FormItem from '../Forms/FormItem'
import SectionsSelector from '../Selectors/SectionsSelector'
import SectionToYearSelector from '../Selectors/SectionToYearSelector'
import { isInstitutionUser, isValidUser } from '../../../utils/roles'
import { selectUser } from '../../../reducers/UserReducer'
import { getEntityOrNull, getIdOrNull } from '../../../utils'
import { ColorsPalette } from '../../../config/colors'
import { SchoolSectionProperties } from '../../../utils/entities/schoolSection'

const FIELD_WIDTH = '100%'
const FIELD_STYLE = { width: FIELD_WIDTH }
const FIELD_ERROR_STYLE = { ...FIELD_STYLE, border: `2px solid ${ColorsPalette.RED}`, borderRadius: '4px' }

const { SCHOOL_YEAR, SECTION, COMMENT } = SchoolSectionProperties

const SchoolSectionForm = ({ data = {}, errorFields = [], sections, sectionToYears, onChange }) => {
  const user = useSelector(selectUser)

  const handleSectionChange = (value, _, entity) => onChange({ ...data, section: getEntityOrNull(entity ?? value), sectionToYear: null })
  const handleSectionToYearChange = (value, _, entity) => onChange({ ...data, sectionToYear: getEntityOrNull(entity ?? value) })

  const getStyle = field => errorFields.includes(field) ? FIELD_ERROR_STYLE : FIELD_STYLE

  return (
    <div className='flex-column'>
      <FormItem icon={faGraduationCap} label='school_section.form.section_name' required>
        <SectionsSelector
          sections={sections}
          values={getIdOrNull(data.section)}
          style={getStyle(SECTION)}
          onChange={handleSectionChange}
          multiple='default'
        />
      </FormItem>
      <FormItem icon={faCalendarStar} label='school_section.form.section_to_year' required>
        <SectionToYearSelector
          values={getIdOrNull(data.section) ? getIdOrNull(data.sectionToYear) : null}
          style={getStyle(SCHOOL_YEAR)}
          section={data.section}
          sectionToYears={sectionToYears}
          onChange={handleSectionToYearChange}
          multiple='default'
        />
      </FormItem>
      {isValidUser(user) && !isInstitutionUser(user) && (
        <FormItem icon={faEnvelopeOpenText} label='school_section.form.comment'>
          <Input
            style={getStyle(COMMENT)}
            value={data.comment}
            onChange={e => onChange({ ...data, comment: e.target.value })}
            disabled={isInstitutionUser(user)}
          />
        </FormItem>
      )}
    </div>
  )
}

export default SchoolSectionForm
